import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { ACTIONS } from '../../actions/actionTypes';
import Spinner from '../components/spinner';
import Input from '../components/input';
import PlaySound from '../../sounds/playSound';

class QuestionView extends Component {
    constructor (props) {
        super(props);
        this.state = {
            checked: null,
            stage: 0,
            color: 'black',
            showContinueButton: false,
            showExplanationButton: false,
            startAnswering: false
        };
        this.addAnswer = this.addAnswer.bind(this);
        this.startAnswering = this.startAnswering.bind(this);
        this.continueAfterAnswer = this.continueAfterAnswer.bind(this);
        this.showExplanation = this.showExplanation.bind(this);
    }

    renderQuestion () {
        const {stage} = this.state;
        const {questions} = this.props;
        const question = questions[stage];
        if (question) {
            return (
                <h2>{question.title}</h2>
            );
        }
    }

    renderOptions () {
        const {stage} = this.state;
        const {questions} = this.props;
        const question = questions[stage];
        if (question) {
            const options = question.options;
            return (
                <div className='answer-checkbox-group'>
                    {options.map((item, index) => {
                        const showCorrect = (process.env.NODE_ENV === 'development' && this.props.isCorrect(item));
                        const title = showCorrect ? '• ' + item.title : item.title;
                        return (
                            <div className='question-option' key={index}>
                                <Input
                                    correct={this.props.isCorrect(item)}
                                    textStyle={{color: this.state.color}}
                                    onChange={() => {
                                        if (this.state.showContinueButton === false) {
                                            this.setState({checked: index});
                                            PlaySound('pencilSound');
                                        }
                                    }}
                                    checked={this.state.checked === index}
                                    label={title}
                                />
                            </div>
                        );
                    })}
                </div>
            );
        }
    }

    addAnswer () {
        if (this.state.checked !== null) {
            const {stage} = this.state;
            const {questions} = this.props;

            if (stage < questions.length) {
                const {checked} = this.state;
                const question = questions[stage];
                const option = question.options[checked];
                const obj = {
                    question: question.id,
                    option: option.id
                };

                this.setState({color: 'green'});
                this.props.addAnswerToSession(obj);
                this.setState({showContinueButton: true});

                const hasExplanation = (question.explanation && question.explanation.length > 10);
                const hasCuriosity = (question.curiosityUrl && question.curiosityUrl.length > 5);
                if (hasExplanation || hasCuriosity) {
                    this.setState({showExplanationButton: true});
                    if (!this.props.isCorrect(option)) {
                        this.props.showModalAndStopTimer(
                            question.explanation,
                            question.videoUrl,
                            question.curiosityUrl
                        );
                    }
                }
                if (this.props.isCorrect(option)) {
                    PlaySound('correct');
                } else {
                    PlaySound('wrong');
                }
            }
        }
    }

    showExplanation () {
        const {stage} = this.state;
        const {questions} = this.props;

        if (stage < questions.length) {
            const question = questions[stage];
            this.props.showModalAndStopTimer(
                question.explanation,
                question.videoUrl,
                question.curiosityUrl
            );
        }
    }

    continueAfterAnswer () {
        const {stage} = this.state;

        this.setState({
            checked: null,
            stage: stage + 1,
            color: 'black',
            showExplanationButton: false,
            showContinueButton: false
        });

        if (this.props.shouldFinishSession(stage)) {
            this.props.stopSession();
        }
    }

    startAnswering () {
        this.setState({
            startAnswering: true
        });

        this.props.startTimer();
    }

    render () {
        const level = this.props.user.user.data.level.title;

        if (this.props.loading) {
            return (
                <div className='view-background question default'>
                    <Spinner />
                </div>
            );
        }

        if (!this.state.startAnswering) {
            return (
                <div className='view-background question default'>
                    <div className={'btn start-answering'} onClick={this.startAnswering}>
                        <h4>Começar prova</h4>
                    </div>
                    {process.env.NODE_ENV === 'development'
                        ? <div>
                            <div className={'btn start-answering'} onClick={this.props.sendAllCorrect}>
                                <h4>[DEV] Acertar todas</h4>
                            </div>
                            <div className={'btn start-answering'} onClick={this.props.sendAllWrong}>
                                <h4>[DEV] Errar todas</h4>
                            </div>
                        </div>
                        : null}
                </div>
            );
        }

        return (
            <div className='view-background question default'>
                <div className='desk'>
                    <div className='question-background paper'>
                        <div className='question-text-container'>
                            <div className='text-container'>
                                <div className='header'>
                                    <div>
                                        <h2>{'Exame: '}</h2>
                                        <span>{level}</span>
                                    </div>
                                    <div>
                                        <h2>{'Questão: '}</h2>
                                        <span>{this.state.stage + 1} de {this.props.questions.length}</span>
                                    </div>
                                </div>
                                <div>
                                    <div className='question-container'>
                                        {this.renderQuestion()}
                                    </div>
                                    <div className='options-container'>
                                        {this.renderOptions()}
                                    </div>
                                </div>
                                <div className={'btn center ' + (!this.state.showContinueButton ? '' : 'hide')}
                                    onClick={this.addAnswer}>
                                    <h4>Responder</h4>
                                </div>
                                <div className={'btn center ' + (this.state.showExplanationButton ? '' : 'hide')}
                                    onClick={this.showExplanation}>
                                    <h4>Ver Explicação</h4>
                                </div>
                                <div className={'btn continue ' + (this.state.showContinueButton ? '' : 'hide')}
                                    onClick={this.continueAfterAnswer}>
                                    <h4>Continuar</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({user, questionReducer}) => {
    const {questions, loading} = questionReducer;
    return {user, questions, loading};
};

const mapActionsToProps = (dispatch) => ({
    push: (param) => dispatch(push(param)),
    startTimer: () => dispatch({
        type: ACTIONS.START_TIMER
    })
});

export default connect(mapStateToProps, mapActionsToProps)(QuestionView);



// WEBPACK FOOTER //
// ./src/views/QuestionsView/questionTestView.js